export type Gender = 'male' | 'female' | null;

const LOCAL_STORAGE_KEY = 'selectedGender';

export const setGender = (gender: Gender) => {
  if (gender === null) {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, gender);
  document.dispatchEvent(new CustomEvent('gender:updated'));
};

export const getGender = (): Gender => (
  localStorage.getItem(LOCAL_STORAGE_KEY) as Gender ?? null
);
